import React from 'react';
import { node } from 'prop-types';
import { MenuWrapper } from 'common/mdc/menu';
import Icon from 'common/mdc/icon';
import Button from 'common/mdc/button';
import { userShape } from '../login';

const UserProfile = ({ user, children }) => (
  children ?
    <MenuWrapper
      left={false}
      overlay={false}
      wrappedElement={
        <Button className="profile">
          <Icon className="profile-icon mdc-button__icon">account_circle</Icon>
          {user && (user.name || user.username)}
          <Icon className="mdc-button__icon right">arrow_drop_down</Icon>
        </Button>
      }
    >{React.Children.only(children)}
    </MenuWrapper> :
    <Button className="profile" style={{ cursor: 'default' }}>
      <Icon className="profile-icon mdc-button__icon">account_circle</Icon>
      {user && (user.name || user.username)}
    </Button>
);

UserProfile.propTypes = {
  user: userShape.isRequired,
  children: node,
};

UserProfile.defaultProps = {
  children: null,
};

export default UserProfile;
